import React from 'react';
import { Icon } from './Icon.js';
export const IconRoadmap = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M23.3086 14.9121L23.7363 15.5L23.3086 16.0879L19.3086 21.5879L19.0088 22H6V17H8V20H17.9902L21.2637 15.5L20 13.7617V10.3623L23.3086 14.9121Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M17 3L17 14L5.50001 14L1.5 8.5L5.50001 3L17 3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconRoadmap.js.map